import { getAllReportListFetch } from "../../api/api";
import { osTypeFu } from "../../config/table_comlun";
const state = {
  allreportList: [],
  totalObj: {
    totalEstimateTimes: null, //预估倍数
    totalIncome: null, //收入总计
    totalIncre: null, //总新增
    totalPopu: null, //推广总计
    totalRoi: null, //总roi
  },
};

const actions = {
  async getAllReportList({ commit }, { param, cb }) {
    try {
      const data = await getAllReportListFetch({ data: JSON.stringify(param) });
      cb();
      if (data.code == "0000") {
        data.totalPart.map((v) => {
          v.popuStatus = v.popuStatus == 1 ? "是" : "否";
          v.osType = osTypeFu(v.osType);
          for (let item in v.collec) {
            v[item] = v.collec[item];
          }
        });
        commit("setAllReportList", data);
      }
    } catch (e) {
      throw new Error(e);
    }
  },
};

const mutations = {
  setAllReportList(state, data) {
    state.allreportList = data.totalPart;
    state.totalObj.totalIncome = data.totalIncome;
    state.totalObj.totalIncre = data.totalIncre;
    state.totalObj.totalPopu = data.totalPopu;
    state.totalObj.totalRoi = data.totalRoi;
    state.totalObj.totalEstimateTimes = data.totalEstimateTimes;
    state.totalObj.totalPayPerAdsRate = data.totalPayPerAdsRate;
  },
};

export default {
  state,
  actions,
  mutations,
};
